<div>
  <h2>Partner Colors</h2>
</div>

<alert></alert>

<div class="row">
  <div class="col-lg-6 col-md-12">
    <form [formGroup]="schemeForm">
            <ng-container *ngTemplateOutlet="colorPicker; context: {
                name: 'Primary Color',
                description: 'Main element colors (buttons, navigation, etc.)',
                index: 0, 
                control: schemeForm.get('primary')
            }"></ng-container>
            <ng-container *ngTemplateOutlet="colorPicker; context: {
                name: 'Primary Dark',
                description: 'Button hover color',
                index: 1, 
                control: schemeForm.get('primary_dk')
            }"></ng-container>
      <!-- NOT USED YET -->
            <!-- <ng-container *ngTemplateOutlet="colorPicker; context: {
                name: 'Primary Extra Dark',
                description: '',
                index: 2, 
                control: schemeForm.get('primary_xdk')
            }"></ng-container> -->
            <ng-container *ngTemplateOutlet="colorPicker; context: {
                name: 'Primary Light',
                description: 'Login page image hue color',
                index: 3, 
                control: schemeForm.get('primary_lt')
            }"></ng-container>
            <ng-container *ngTemplateOutlet="colorPicker; context: {
                name: 'Primary Extra Light',
                description: 'Button focus shadow color',
                index: 4, 
                control: schemeForm.get('primary_xlt')
            }"></ng-container>

    <div class="bottom-button-container">
      @if (!isDone) {
        <button class="btn btn-primary" type="button" [disabled]="schemeForm.invalid"
          (click)="!showSubmitButton ? previewColorScheme() : submitAndSetColorScheme()">
          {{ !showSubmitButton? 'Preview Color Scheme' : 'Set Partner Theme' }}
        </button>
      }
      @if (!isDone) {
        <button class="btn btn-outline-secondary" type="button"
          (click)="showRevertButton ? revertColorScheme() : navigateBack()">
          {{ showRevertButton ? 'Revert' : 'Cancel' }}
        </button>
      }
      @if (isDone) {
        <button class="btn btn-primary" type="button"
          (click)="navigateBack()">
          Done
        </button>
      }
    </div>
  </form>
</div>

<div class="preview-container col-lg-6 col-md-12">
  <form [style.width.%]="100" [formGroup]="schemeForm">
            <ng-container *ngTemplateOutlet="colorPicker; context: {
                name: 'Top Bar - Left',
                description: 'Left gradient color on top header bar',
                index: 5,
                control: schemeForm.get('topbar_left')
            }"></ng-container>
            <ng-container *ngTemplateOutlet="colorPicker; context: {
                name: 'Top Bar - Right',
                description: 'Right gradient color on top header bar',
                index: 6,
                control: schemeForm.get('topbar_right')
            }"></ng-container>

    <div class="form-group">
      <label for="logoFileUpload">Upload logo</label>
      <div class="custom-file">
        <input type="file" accept="image/png, image/jpeg" class="form-control custom-file-input" id="logoFileUpload"
          [ngClass]="{ 'is-invalid': schemeForm.controls.logo.errors }" (change)="onFileChange($event)">
        <label class="custom-file-label" for="logoFileUpload">
          {{ schemeForm.get('logo').value.name ? schemeForm.get('logo').value.name : 'Choose Image' }}
        </label>
        @if (schemeForm.controls.logo.errors) {
          @if (schemeForm.controls.logo.errors.maxFileSizeExceeded) {
            <div class="invalid-feedback">Max file size is {{ maxFileSizeMb }} Mb</div>
          }
        }
      </div>
    </div>
  </form>

  <div class="preview-wrapper">
    <h3 [style.margin-top]="'0'" [style.text-decoration]="'underline'">Preview Components</h3>
    @for (val of dummyArray | paginate: {
      itemsPerPage: 2,
      currentPage: currentPage,
      totalItems: 20
      }; track val) {
    }
    <pagination-controls (pageChange)="currentPage = $event"></pagination-controls>
    <div class="horizontal-wrapper">
      <button class="btn btn-primary" type="button">Primary Button</button>
      <button class="btn btn-outline-secondary" type="button">Secondary</button>
      <label class="switch">
        <input type="checkbox" [checked]="switchChecked" (change)="switchChecked = $event.checked" [(ngModel)]="switchChecked">
        <span class="slider"></span>
      </label>
    </div>
  </div>
</div>
</div>

<!-- Color picker form control template -->
<ng-template #colorPicker let-name="name" let-control="control" let-description="description" let-index="index">
  <div class="form-group">
    <label class="color-picker-label" [for]="name">
      {{ name }}
    </label>
    <div class="input-group">
      <div class="input-group-prepend color-preview" (click)="openNgxColorPicker(index, $event)">
        <div class="input-group-text">
          @if (control.value) {
            <div class="color-selector" [style.background-color]="control.value"></div>
          }
          @if (!control.value) {
            <div class="no-color-icon"><i class="fas fa-tint-slash"></i></div>
          }
        </div>
      </div>
      <input [formControl]="control" (click)="openNgxColorPicker(index, $event)"
        [id]="name" type="text" class="form-control"
        autocomplete="off" [ngClass]="{ 'is-invalid': control.errors }"
        [placeholder]="name === 'Primary Color' ? 'Primary Color*' : 'Will be calculated from primary color'">



      @if (control.errors) {
        @if (control.errors.pattern) {
          <div class="invalid-feedback">Invalid Hex color code</div>
        }
        @if (control.errors.required) {
          <div class="invalid-feedback">Primary color is required</div>
        }
      }
    </div>
    @if (description) {
      <small class="form-text text-muted">{{ description }}</small>
    }

    @if (showColorPicker[index]) {
      <div (clickOutside)="closeNgxColorPicker(index, $event)" #ngxColorWrapper class="ngx-color-wrapper">
        <color-chrome [color]="control.value || 'white'" (onChangeComplete)="handleChangeComplete(control, $event.color)"></color-chrome>
      </div>
    }
  </div>
</ng-template>
